var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseRecommendation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 124",
    style: {
      enableBackground: "new 0 0 120 124"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.62,109.49c-1.07,0-2.07-0.31-2.94-0.94c-1.67-1.21-2.39-3.27-1.99-5.66l4.93-28.98c0.14-0.84-0.39-2.48-1-3.08 L6.54,50.35c-1.74-1.69-2.37-3.78-1.74-5.74c0.63-1.96,2.37-3.29,4.77-3.64l29.08-4.27c0.85-0.12,2.24-1.14,2.62-1.91L54.24,8.43 C55.31,6.25,57.11,5,59.16,5l0,0c2.06,0,3.86,1.24,4.93,3.41l13.04,26.34c0.38,0.77,1.78,1.78,2.62,1.9l29.09,4.18 c2.4,0.35,4.14,1.67,4.78,3.62c0.64,1.96,0.01,4.05-1.72,5.75L90.9,70.75c-0.61,0.6-1.14,2.24-1,3.08l5.01,28.96 c0.41,2.39-0.31,4.46-1.97,5.67s-3.85,1.26-6,0.13L60.91,94.96c-0.76-0.4-2.48-0.4-3.24,0l-25.99,13.71 C30.65,109.22,29.61,109.49,28.62,109.49z M59.28,87.36c1.78,0,3.56,0.38,5.02,1.14l22.8,11.95l-4.39-25.37 c-0.56-3.24,0.74-7.25,3.09-9.54l18.41-18l-25.49-3.67c-3.25-0.47-6.66-2.94-8.12-5.88L59.18,14.91L47.82,38.02 c-1.45,2.95-4.86,5.43-8.11,5.9l-25.47,3.74L32.7,65.61c2.35,2.29,3.66,6.3,3.11,9.53l-4.32,25.38l22.77-12.01 C55.72,87.75,57.5,87.36,59.28,87.36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseRecommendation);
export default __webpack_public_path__ + "static/media/courseRecommendation.608778359028e18605877822fd76c444.svg";
export { ForwardRef as ReactComponent };